module.exports = __webpack_public_path__ + "fonts/Vazir.331c3931.woff";